// test80
(80 && 0);
